/**
 * @generated SignedSource<<c9a4c3ccf91e2ee3e764733c9e1b5e3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type serviceCredits_fragmentAddonQuery$variables = {
  addonKey: string;
  currencyCode: string;
};
export type serviceCredits_fragmentAddonQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"serviceCreditsAddon_fragment">;
};
export type serviceCredits_fragmentAddonQuery = {
  response: serviceCredits_fragmentAddonQuery$data;
  variables: serviceCredits_fragmentAddonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "addonKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currencyCode"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "addonKey",
    "variableName": "addonKey"
  },
  {
    "kind": "Variable",
    "name": "currencyCode",
    "variableName": "currencyCode"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceCredits_fragmentAddonQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "serviceCreditsAddon_fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "serviceCredits_fragmentAddonQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Addon",
        "kind": "LinkedField",
        "name": "addon",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "addonID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddonRate",
            "kind": "LinkedField",
            "name": "rates",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "feeValue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "usageFrom",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rateID",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b4e3e883e812dba0aff985c0893bb687",
    "id": null,
    "metadata": {},
    "name": "serviceCredits_fragmentAddonQuery",
    "operationKind": "query",
    "text": "query serviceCredits_fragmentAddonQuery(\n  $addonKey: String!\n  $currencyCode: String!\n) {\n  ...serviceCreditsAddon_fragment_1OhAiz\n}\n\nfragment serviceCreditsAddon_fragment_1OhAiz on Query {\n  addon(addonKey: $addonKey, currencyCode: $currencyCode) {\n    addonID\n    name\n    rates {\n      feeValue\n      usageFrom\n      rateID\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1d05f0741dd89db9861dd1e93858c71f";

export default node;
